import type { FaireProductEntity } from "../../entity_types/product";

export const p_am7r7ef2h2: FaireProductEntity = {
  token: "p_am7r7ef2h2",
  type: "product",
  name: "Lemon Flat Note Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/8918eeba3349d567e02fb26fcc4f25dd3d64b16d0aa104c05cc8055ee4af4332.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/07d01d5fb5b612a633d80f587a5387747ef80e828b3960d6cfc5fb7a9e36d24a.jpeg",
    "https://cdn.faire.com/fastly/57a1da00dc60a9de064fbd796410329ebe5a4dd05d7b8852d63fdda188d1a2fd.jpeg",
  ],
  priceDollars: 8,
  description:
    'A flat note is concise and smart. Not ostentatious, but clever. And without too much room, you can get right to the point, or be "well-edited" as we like to say.\n\nThis set includes 8 envelopes and 8 beautifully illustrated notecards, each with an extra illustration on the back.',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:46.138Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
